/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_SpeakerInputs */



/**
* | output |
* | --- |
* | "Insert Speaker" |
*
* @param {Shortcut_Keys_Name_Insert_SpeakerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_speaker = /** @type {((inputs?: Shortcut_Keys_Name_Insert_SpeakerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_SpeakerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecher einbauen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить динамик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入扬声器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alto-falante de inserção")
	return /** @type {LocalizedString} */ ("Insert Speaker")
});